import React, { useEffect, useRef, useState } from "react";
import { Alert, Button, Form } from "react-bootstrap";
import { apiGetMerchantPaymentClaims, apiSubmitMerchantPaymentClaim } from "../../api";

export default function MerchantPaymentClaims({ orderId, disabled, onBusyChange }) {
  const [claims, setClaims] = useState([]);
  const [provider, setProvider] = useState("MTN");
  const [transactionId, setTransactionId] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  const mounted = useRef(false);
  const submitting = useRef(false);
  useEffect(() => {
    mounted.current = true;
    apiGetMerchantPaymentClaims(orderId).then(({ data }) => {
      if (mounted.current) setClaims(data.data.claims);
    }).catch(err => { if (mounted.current) setError(err.response?.data?.message || "Could not load transaction reports."); })
      .finally(() => { if (mounted.current) setLoading(false); });
    return () => { mounted.current = false; };
  }, [orderId]);
  const submit = async event => {
    event.preventDefault();
    if (submitting.current || disabled || loading) return;
    submitting.current = true; onBusyChange?.(true); setError(""); setNotice("");
    try {
      const { data } = await apiSubmitMerchantPaymentClaim(orderId, { provider, transactionId: transactionId.trim() });
      if (mounted.current) {
        setNotice(data.data.message);
        setClaims(previous => [data.data.claim, ...previous.filter(c => c.id !== data.data.claim.id)]);
        setTransactionId("");
      }
    } catch (err) { if (mounted.current) setError(err.response?.data?.message || "Could not record the report. Refresh before submitting again."); }
    finally { submitting.current = false; if (mounted.current) onBusyChange?.(false); }
  };
  return <section aria-label="Merchant transaction reports">
    <h5>Customer already sent a merchant payment?</h5>
    <p>Record the transaction ID they provided. It remains unverified until independently checked with the provider. Recording it does not mark this order paid. Do not request a new payment here.</p>
    {error && <Alert variant="danger">{error}</Alert>}
    {notice && <Alert variant="info">{notice}</Alert>}
    {loading ? <p>Loading reports…</p> : <>
      {claims.length > 0 && <ul>{claims.map(claim => <li key={claim.id} style={{ overflowWrap: "anywhere" }}>
        {claim.provider}: {claim.transactionId} · Unverified · {claim.reportSource === "CUSTOMER" ? "Reported by customer" : "Reported by staff"}
      </li>)}</ul>}
      <Form onSubmit={submit}>
        <Form.Group controlId="merchantClaimProvider"><Form.Label>Payment network</Form.Label>
          <Form.Control as="select" value={provider} disabled={disabled} onChange={e => setProvider(e.target.value)}>
            <option value="MTN">MTN</option><option value="AIRTEL">Airtel</option>
          </Form.Control>
        </Form.Group>
        <Form.Group controlId="merchantClaimTransaction"><Form.Label>Customer-provided transaction ID</Form.Label>
          <Form.Control value={transactionId} maxLength={80} disabled={disabled} autoComplete="off" onChange={e => setTransactionId(e.target.value)} />
          <Form.Text>Enter the transaction ID only. Never enter a wallet PIN or OTP.</Form.Text>
        </Form.Group>
        <Button type="submit" variant="outline-primary" disabled={disabled || !/^[A-Za-z0-9][A-Za-z0-9._:/-]{3,79}$/.test(transactionId.trim())}>Record unverified transaction ID</Button>
      </Form>
    </>}
  </section>;
}
